import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { Checkbox, Radio } from 'antd';
import Panel from '../../../components/Panel';
import SPICEFileSelect from './components/SPICEFileSelect';
import SubcktNodeSelect from './components/SubcktNodeSelect';
import libraryConstructor from '../../../services/Andes_v2/library/libraryConstructor';
import { BUFFER_SPICE, IBIS, SPICE } from '../../../constants/libraryConstants';
import {
  handleSelectSubckt,
  getNodeSelectOption,
  getSubcktByPairInfo,
  onlyModelTitle,
  handleChangeSpiceType,
  handleSelectFile,
  handleSelectNode,
  getModelKey,
  getFileTreeData,
  getIBISModelSelectList,
  getNextNodeVisible
} from '../../../services/Andes_v2/simulation';
import IBISRender from './components/IBISRender';
/**
 * IBIS: only support select 1 library file
 * SPICE：1 library file or 3 library file
 */
class RxModel extends Component {
  constructor() {
    super();
    this.state = {
      applyAll: false,
      spiceType: 'only', // only / share
      ibisLibraryList: libraryConstructor.getLibraryValues(IBIS) || [],
      fileTreeData: [],
      modelNameSelectList: [],
      modelTypeSelectList: [],
      selectorModels: [],
      model: {
        files: [],
        pairs: [],
        pinModels: [],
        type: "ibis"
      },
      nodeVisible: '',
      subcktList: {}
    }
    this.dialogRoot = document.getElementById('root');
  }

  async componentDidMount() {
    const { model } = this.props;
    document.addEventListener('mousedown', this.handleClickOutside, true);
    const { files, type } = model;
    let spiceType = 'only', modelNameSelectList = [], modelTypeSelectList = [], selectorModels = [];
    let fileTreeData = [];
    if (type === IBIS) {
      const file = files[0] || {};
      const selectListInfo = await getIBISModelSelectList(file, 'Rx');
      modelNameSelectList = selectListInfo.modelNameSelectList;
      modelTypeSelectList = selectListInfo.modelTypeSelectList;
      selectorModels = selectListInfo.selectorModels;
    } else {
      spiceType = files.length > 1 ? 'only' : 'share';
      fileTreeData = await getFileTreeData([SPICE, BUFFER_SPICE], model.files)
    }
    this.setState({
      model: JSON.parse(JSON.stringify(model)),
      spiceType,
      modelNameSelectList,
      modelTypeSelectList,
      selectorModels,
      fileTreeData
    }, () => {
      type === IBIS && this.IBISRenderRef && this.IBISRenderRef.getIBISPinAndModelColumns();
      this.isMountedFlag = true;
    })
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  async componentDidUpdate(prevProps) {
    const { libraryStatus, model } = this.props;
    if (prevProps.libraryStatus !== libraryStatus) {
      this.setState({
        ibisLibraryList: libraryConstructor.getLibraryValues(IBIS),
        fileTreeData: await getFileTreeData([SPICE, BUFFER_SPICE], model.files)
      })
    }
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const { nodeVisible } = this.state;
    const PopoverRoot = document.getElementById(nodeVisible);

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || !PopoverRoot.contains(target)) {
      this.setState({ nodeVisible: '' });
    }
  }

  closeModal = () => {
    const { model, applyAll } = this.state;
    if (this.isMountedFlag) {
      this.props.closeModal(model, applyAll);
    }
  }

  changeModelType = async (value) => {
    const { model, fileTreeData } = this.state;
    let _pinModels = [...model.pinModels], type = model.type, _pairs = [...model.pairs], _fileTreeData = [];

    // switch type post-processing, clear files, clear pinModels data about file selection
    if (type === IBIS) {
      _pinModels = _pinModels.map(item => {
        return { ...item, libraryId: "", fileName: "", modelName: "", modelType: "" }
      })
      if (!fileTreeData.length) {
        _fileTreeData = await getFileTreeData([SPICE, BUFFER_SPICE], [])
      }
    } else {
      _pairs = _pairs.map(item => {
        return { node: "", pin: item.pin, net: item.net }
      })
    }

    this.setState({
      model: {
        type: value,
        files: [],
        pinModels: [..._pinModels],
        pairs: [..._pairs]
      },
      spiceType: 'share',
      fileTreeData: [..._fileTreeData]
    }, () => {
      value === IBIS && this.IBISRenderRef && this.IBISRenderRef.getIBISPinAndModelColumns();
    })
  }

  IBISRender = () => {
    const { ibisLibraryList, modelTypeSelectList, modelNameSelectList, selectorModels, model } = this.state;
    return <IBISRender
      ibisLibraryList={ibisLibraryList}
      modelTypeSelectList={modelTypeSelectList}
      selectorModels={selectorModels}
      modelNameSelectList={modelNameSelectList}
      model={model}
      setModelInfo={(params) => this.setState({ ...params })}
      ref={(ref) => this.IBISRenderRef = ref}
      type="Rx"
    />
  }

  changeSpiceType = (type) => {
    const { model, subcktList: prevSubcktList } = this.state;
    const { files, pairs, subcktList } = handleChangeSpiceType(model, type, prevSubcktList);
    this.setState({ spiceType: type, model: { ...model, files, pairs }, subcktList })
  }

  selectModelFile = (file, fileIndex) => {
    const { model, subcktList } = this.state;
    const { files, pairs } = handleSelectFile('rxModel', model, file, fileIndex);
    this.setState({ model: { ...model, files, pairs }, subcktList: { ...subcktList, [fileIndex]: {} } });
  }

  selectSubckt = (subckt, modelKey, file) => {
    const { model, subcktList } = this.state;
    const { files, pairs } = handleSelectSubckt('rxModel', model, subckt, modelKey, file);
    const _file = files.find(item => item.modelKey === modelKey) || {};
    this.setState({ model: { ...model, files, pairs }, subcktList: { ...subcktList, [modelKey]: { ...subckt, ..._file } } })
  }

  selectNode = (node, pairIndex, modelKey) => {
    const { model, spiceType } = this.state;
    const pairs = handleSelectNode(model, spiceType, node, pairIndex, modelKey);
    let nodeVisible = "";
    if (node) {
      const { _nodeVisible, _nextPairIndex } = getNextNodeVisible(pairs, pairIndex, "rx-model-subckt-node-popover");
      nodeVisible = _nodeVisible;
      if (_nextPairIndex !== -1) {
        this.setNodeVisible(
          nodeVisible,
          pairs[_nextPairIndex],
          _nextPairIndex,
          true
        )
      }
    }
    this.setState({ model: { ...model, pairs }, nodeVisible });
  }

  clearNodeVisible = () => {
    this.setState({ nodeVisible: "" })
  }

  setNodeVisible = async (visible, pair, pairIndex, isReturnVisible) => {
    const { subcktList, model: { files }, spiceType } = this.state;
    const _modelKey = getModelKey({ spiceType, files, modelKey: pair.modelKey, pairIndex });
    const fileInfo = pair.node ? pair : files.length > 1 ? files.find(file => file.modelKey === _modelKey) : files[0];
    if (visible && !Object.keys(subcktList[_modelKey] || {}).length && fileInfo) {
      const subcktInfo = await getSubcktByPairInfo(fileInfo);
      this.setState({ subcktList: { ...subcktList, [_modelKey]: subcktInfo } });
    }
    if (isReturnVisible) {
      return visible;
    }
    this.setState({ nodeVisible: visible })
  }

  getNodeOption = (spiceType, sharePairs, onlyPairs, modelKey, pairIndex) => {
    const { subcktList, model: { files } } = this.state;
    const _modelKey = getModelKey({ spiceType, files, modelKey, pairIndex });
    const pairs = spiceType === 'only' ? onlyPairs : sharePairs;
    const subckt = subcktList[_modelKey];
    return getNodeSelectOption('rxModel', pairs, subckt)
  }

  updateFileTreeData = (children) => {
    const { fileTreeData } = this.state;
    this.setState({ fileTreeData: fileTreeData.concat(children) })
  }

  SPICERender = () => {
    const { spiceType, model: { files, pairs }, nodeVisible, fileTreeData } = this.state;
    return (<>
      {/* Model File */}
      {files.length !== 0 ? files.map((file, index) => <div key={`${file.libraryId}-${index}` || `rx-model-${index}`}>
        <SPICEFileSelect
          fileTreeData={fileTreeData}
          selectModelFile={(file) => this.selectModelFile(file, file.modelKey || index)}
          selectSubckt={(subckt) => this.selectSubckt(subckt, file.modelKey, file)}
          file={file}
          spiceType={spiceType}
          changeSpiceType={this.changeSpiceType}
          modelFileTitle={spiceType === 'only' ? onlyModelTitle[index] : "Model File"}
          updateFileTreeData={this.updateFileTreeData}
        />
      </div>) : <SPICEFileSelect
        fileTreeData={fileTreeData}
        selectModelFile={(file) => this.selectModelFile(file, -1)}
        selectSubckt={(subckt) => this.selectSubckt(subckt, -1)}
        file={{}}
        spiceType={spiceType}
        changeSpiceType={this.changeSpiceType}
        updateFileTreeData={this.updateFileTreeData}
      />}
      {/* Select Node */}
      <div className="andes-v2-hspice-simulation-rx-model">
        <div className='andes-v2-hspice-simulation-rx-model-title-item'>
          <span>Net</span>
          <span className='andes-v2-hspice-simulation-rx-model-pin'>Pin</span>
          <div className='andes-v2-hspice-simulation-rx-model-node-select'>Node</div>
        </div>
        {pairs.map((item, index) => (
          <div className='andes-v2-hspice-simulation-rx-model-item' key={`rx-model-${item.net}`}>
            {/* net */}
            <span title={item.net}>{item.net}</span>
            <hr />
            {/* pin */}
            <span className='andes-v2-hspice-simulation-rx-model-pin' title={item.pin}>{item.pin}</span>
            {/* node */}
            <div className='andes-v2-hspice-simulation-rx-model-node-select'>
              <SubcktNodeSelect
                id={`rx-model-subckt-node-popover-${item.pin}`}
                nodeWidth={100}
                displayPin={item.pin}
                nodeValue={item.node}
                nodeList={this.getNodeOption(spiceType, pairs, [item], item.modelKey, index)}
                selectNode={(node) => this.selectNode(node, index, item.modelKey)}
                visible={nodeVisible === `rx-model-subckt-node-popover-${item.pin}`}
                clickNode={() => this.setNodeVisible(`rx-model-subckt-node-popover-${item.pin}`, item, index)}
                closeNodelSelect={() => this.clearNodeVisible()}
              />
            </div>
          </div>))}
      </div>
    </>)
  }

  applyChange = (e) => {
    this.setState({ applyAll: e.target.checked })
  }

  render() {
    const { applyAll, model: { type } } = this.state;
    const content = (
      <Panel
        className='andes-v2-model-panel'
        position='panel-center-left'
        title='Rx Buffer'
        zIndex={2000}
        onCancel={() => this.closeModal()}
        width={600}
        draggable
        minHeight={200}
      >
        <div className='andes-v2-hspice-simulation-model-content'>
          {/* Model Type */}
          <div className='andes-v2-hspice-simulation-flex'>
            <span className='andes-v2-hspice-simulation-title'>Model Type</span>
            <Radio.Group onChange={(e) => this.changeModelType(e.target.value)} value={type}>
              <Radio value={IBIS}>IBIS</Radio>
              <Radio value={SPICE}>SPICE</Radio>
            </Radio.Group>
          </div>
          {type === IBIS ? this.IBISRender() : this.SPICERender()}
          {<div className="ads-model-apply-all-content">
            <span>Apply setting to all signal</span>
            <Checkbox
              checked={applyAll}
              onChange={(e) => this.applyChange(e)}
            />
          </div>}
        </div>
      </Panel >
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default RxModel;